import React, { useEffect, useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import queryString from "query-string";
import InterestContext from "../context/interest/interestContext";
import InformationDisplay from "../components/InformationDisplay";
import LoadingSpinner from "../components/utilities/LoadingSpinner";


const InformationActionPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const interestContext = useContext(InterestContext);
  const {
    getSiteprogram,
    Siteprogram,
    getSiteInformation,
    siteInformation,
    setCampaignType,
  } = interestContext;
  useEffect(() => {
    var query = queryString.parse(location.search);
    if (query.site) {
      getSiteprogram(query.site);// // ← THIS TRIGGERS THE DATA FETCH
    } else {
      navigate("/");
    }
    if (query.campaign) {
      setCampaignType(query.campaign);
    }
  }, []);

  const brandName = Siteprogram && Siteprogram.charter && Siteprogram.charter.brand && Siteprogram.charter.brand.brandName;

  return (
    <section id="information-action">
      <Helmet>
        <meta charSet="utf-8" />
        <title>{brandName ? `${brandName} | Enrollments` :"Student Enrollment"}</title>
      </Helmet>
      <div className="info-header">
        <div className="container">
          <div className="call">
            <p></p>
          </div>
        </div>
      </div>
      {/* <div className="brand-header">
        <div className="container">
          <Link to="/">
            <img src={l4lLogo} alt="" className="branding-logo" />
          </Link>
        </div>
      </div> */}
      {!Siteprogram || Object.keys(Siteprogram).length === 0 ? (
        <LoadingSpinner />
      ) : (
        <InformationDisplay data={Siteprogram} />
      )}
    </section>
  );
};

export default InformationActionPage;

